document.querySelectorAll('.product-item').forEach(item => {
  item.addEventListener('mouseenter', function (){
      item.querySelector('.second__slide') && item.querySelector('.second__slide').classList.add('fade-in');
  })
  item.addEventListener('mouseleave', function (){
      item.querySelector('.second__slide') && item.querySelector('.second__slide').classList.remove('fade-in');
  })
})

let scrollDesktop = null;
let currentProgress = null;

const initLoco = () => {
    scrollDesktop = new LocomotiveScroll({
      el: document.querySelector('[data-scroll-container]'),
      smooth: true
    });

    scrollDesktop.on('scroll', (args) => {
        currentProgress = parseInt((args.scroll.y/args.limit.y)*100);
        document.querySelector('.progress-bar__progress').style.width = currentProgress + '%';
        // $('.js-progress-scroll').css('stroke-dasharray', `${(args.scroll.y/args.limit.y)*265}, 999`);

        if (args.scroll.y > $(window).height()) {
            $('.js-progress-scroll').addClass('backtotop--show');
        } else {
            $('.js-progress-scroll').removeClass('backtotop--show');
        }

      if ($('body').hasClass('template-product')) {
        const activeSection = $('.tab-section.is-inview').attr('id');
        $('.sticky__item .item-tab').each(function () {
          if ($(this).hasClass(activeSection)) {
          	$(this).addClass('active');
            $(this).siblings('.item-tab').removeClass('active');
          }
        });

        if ($('.js-recomend-section').offset().top - 700 <= 0) {
        	$('.js-pdp-navbar .sticky__inner').addClass('none');
        } else {
        	$('.js-pdp-navbar .sticky__inner').removeClass('none');
        }
	}


        // if(typeof args.currentElements['banner'] === 'object') {
        //   document.querySelector('body').style.backgroundColor = '#000';
        // }

        // if(typeof args.currentElements['text-section'] === 'object') {
        //   document.querySelector('body').style.backgroundColor = '#000';
        // }

        // if(typeof args.currentElements['card-section'] === 'object') {
        //   document.querySelector('body').style.backgroundColor = '#000';
        // }

        // if(typeof args.currentElements['static-section'] === 'object') {
        //   document.querySelector('body').style.backgroundColor = '#000';
        // }

        if(typeof args.currentElements['background-image'] === 'object') {
            let progress = args.currentElements['background-image'].progress;
            let currentOpacity, titleOpacity;


            if(progress < 0.75) {
              currentOpacity =  1.5 - progress;
            }  else if (progress < 0.90) {
              currentOpacity =  1.25 - progress;
            } else {
               currentOpacity = 1 - progress;
            }

            if (progress > 0.5 ) {
              titleOpacity = (0.8 - progress) * 4;
            }
            document.querySelector('.background-image-container').style.opacity = currentOpacity;
            document.querySelector('#banner .title-container').style.opacity = titleOpacity;
        }

        if(typeof args.currentElements['card-img-1'] === 'object') {
            let progress = args.currentElements['card-img-1'].progress;
            let currentScale = 1.5 - (progress / 2) ;

            document.querySelector('.card-item__wrapper-1 img').style.transform = 'scale(' + currentScale +')';
        }

        if(typeof args.currentElements['card-img-2'] === 'object') {
            let progress = args.currentElements['card-img-2'].progress;
            let currentScale = 1.5 - (progress / 2) ;

            document.querySelector('.card-item__wrapper-2 img').style.transform = 'scale(' + currentScale +')';
        }

        if(typeof args.currentElements['card-img-3'] === 'object') {
            let progress = args.currentElements['card-img-3'].progress;
            let currentScale = 1.5 - (progress / 2) ;

            document.querySelector('.card-item__wrapper-3 img').style.transform = 'scale(' + currentScale +')';
        }

        if(typeof args.currentElements['expanding-video'] === 'object') {
            let progress = args.currentElements['expanding-video'].progress;
            let currentSize = 80 - (progress * 170);

            if(currentSize > -1){
              document.querySelector('.ambassador-pdp-video .border-left').style.width = currentSize + 'px';
              document.querySelector('.ambassador-pdp-video .border-right').style.width = currentSize + 'px';
              document.querySelector('.ambassador-pdp-video .border-top').style.height = currentSize + 'px';
            } else {
              document.querySelector('.ambassador-pdp-video .border-left').style.width = '0px';
              document.querySelector('.ambassador-pdp-video .border-right').style.width = '0px';
              document.querySelector('.ambassador-pdp-video .border-top').style.height = '0px';
            }

            let textHeight = 80 - (progress * 150);

            if(textHeight > -1) {
              document.querySelector('.ambassador-pdp-video .slow-content').style.top = textHeight + 'vh';
            } else {
              document.querySelector('.ambassador-pdp-video .slow-content').style.top = '0';
            }
        }

        if(typeof args.currentElements['full-width-pdp-image'] === 'object') {
            let progress = args.currentElements['full-width-pdp-image'].progress;
            let currentSize = 80 - (progress * 170);

            if(currentSize > -1){
                document.querySelector('.full-width-pdp-image .border-left').style.width = currentSize + 'px';
                document.querySelector('.full-width-pdp-image .border-right').style.width = currentSize + 'px';
                document.querySelector('.full-width-pdp-image .border-top').style.height = currentSize + 'px';
            } else {
                document.querySelector('.full-width-pdp-image .border-left').style.width = '0px';
                document.querySelector('.full-width-pdp-image .border-right').style.width = '0px';
                document.querySelector('.full-width-pdp-image .border-top').style.height = '0px';
            }

            let textHeight = 80 - (progress * 150);

            if(textHeight > -1) {
                document.querySelector('.full-width-pdp-image .slow-content').style.top = textHeight + 'vh';
            } else {
                document.querySelector('.full-width-pdp-image .slow-content').style.top = '0';
            }
        }


        if(typeof args.currentElements['keep-section'] === 'object') {
            let progress = args.currentElements['keep-section'].progress;
            let currentSize = 80 - (progress * 170);
            let titleOpacity;

            if(currentSize > -1){
                document.querySelector('.keep .border-left').style.width = currentSize + 'px';
                document.querySelector('.keep .border-right').style.width = currentSize + 'px';
                document.querySelector('.keep .border-top').style.height = currentSize + 'px';
            } else {
                document.querySelector('.keep .border-left').style.width = '0px';
                document.querySelector('.keep .border-right').style.width = '0px';
                document.querySelector('.keep .border-top').style.height = '0px';
            }

            let textHeight = 60 - (progress * 150);

            if(textHeight > -1) {
                document.querySelector('.keep__content').style.top = textHeight + 'vh';
            } else {
                document.querySelector('.keep__content').style.top = '0';
            }

            if (progress > 0.3 ) {
                titleOpacity = progress + 0.25;
            } else {
                titleOpacity = 0;
            }

            document.querySelector('.keep__content').style.opacity = titleOpacity;
        }


        if(typeof args.currentElements['static-section-1'] === 'object') {
           const staticElement = args.currentElements['static-section-1'].el;
           const imageUrl = staticElement.dataset.image;
           document.querySelectorAll('.static-desktop .static__item').forEach(item => {
             item.style.opacity = 0.4;
           })
           staticElement.style.opacity = 1;
           document.querySelector('.static-desktop .static__item-img').style.transform = 'translateY(0px)';
           document.querySelector('.static-desktop .static__item-img img').setAttribute( 'src', imageUrl);
           document.querySelector('body').style.overflow = "hidden";
        }

        if(typeof args.currentElements['static-section-2'] === 'object') {
          const staticElement = args.currentElements['static-section-2'].el;
          const imageUrl = staticElement.dataset.image;
          document.querySelectorAll('.static-desktop .static__item').forEach(item => {
            item.style.opacity = 0.4;
          })
          staticElement.style.opacity = 1;
          document.querySelector('.static-desktop .static__item-img').style.transform = 'translateY(350px)';
          document.querySelector('.static-desktop .static__item-img img').setAttribute( 'src', imageUrl);
       }

       if(typeof args.currentElements['static-section-3'] === 'object') {
          const staticElement = args.currentElements['static-section-3'].el;
          const imageUrl = staticElement.dataset.image;
          document.querySelectorAll('.static-desktop .static__item').forEach(item => {
            item.style.opacity = 0.4;
          })
          staticElement.style.opacity = 1;
          document.querySelector('.static-desktop .static__item-img').style.transform = 'translateY(700px)';
          document.querySelector('.static-desktop .static__item-img img').setAttribute( 'src', imageUrl);
       }

       if(typeof args.currentElements['static-section-4'] === 'object') {
          const staticElement = args.currentElements['static-section-4'].el;
          const imageUrl = staticElement.dataset.image;
          document.querySelectorAll('.static-desktop .static__item').forEach(item => {
            item.style.opacity = 0.4;
          })
          staticElement.style.opacity = 1;
          document.querySelector('.static-desktop .static__item-img').style.transform = 'translateY(1050px)';
          document.querySelector('.static-desktop .static__item-img img').setAttribute( 'src', imageUrl);
       }

       if(typeof args.currentElements['static-section-5'] === 'object') {
          const staticElement = args.currentElements['static-section-5'].el;
          const imageUrl = staticElement.dataset.image;
          document.querySelectorAll('.static-desktop .static__item').forEach(item => {
            item.style.opacity = 0.4;
          })
          staticElement.style.opacity = 1;
          document.querySelector('.static-desktop .static__item-img').style.transform = 'translateY(1400px)';
          document.querySelector('.static-desktop .static__item-img img').setAttribute( 'src', imageUrl);
       }

        if(typeof args.currentElements['static-section-6'] === 'object') {
            const staticElement = args.currentElements['static-section-6'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop .static__item').forEach(item => {
                item.style.opacity = 0.4;
            })
            staticElement.style.opacity = 1;
            document.querySelector('.static-desktop .static__item-img').style.transform = 'translateY(1750px)';
            document.querySelector('.static-desktop .static__item-img img').setAttribute( 'src', imageUrl);
        }

        if(typeof args.currentElements['static-section-7'] === 'object') {
            const staticElement = args.currentElements['static-section-7'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop .static__item').forEach(item => {
                item.style.opacity = 0.4;
            })
            staticElement.style.opacity = 1;
            document.querySelector('.static-desktop .static__item-img').style.transform = 'translateY(2100px)';
            document.querySelector('.static-desktop .static__item-img img').setAttribute( 'src', imageUrl);
        }

        if(typeof args.currentElements['static-section-8'] === 'object') {
            const staticElement = args.currentElements['static-section-8'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop .static__item').forEach(item => {
                item.style.opacity = 0.4;
            })
            staticElement.style.opacity = 1;
            document.querySelector('.static-desktop .static__item-img').style.transform = 'translateY(2450px)';
            document.querySelector('.static-desktop .static__item-img img').setAttribute( 'src', imageUrl);
        }

        if(typeof args.currentElements['static-section-9'] === 'object') {
            const staticElement = args.currentElements['static-section-9'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop .static__item').forEach(item => {
                item.style.opacity = 0.4;
            })
            staticElement.style.opacity = 1;
            document.querySelector('.static-desktop .static__item-img').style.transform = 'translateY(2800px)';
            document.querySelector('.static-desktop .static__item-img img').setAttribute( 'src', imageUrl);
        }

        if(typeof args.currentElements['static-section-10'] === 'object') {
            const staticElement = args.currentElements['static-section-10'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop .static__item').forEach(item => {
                item.style.opacity = 0.4;
            })
            staticElement.style.opacity = 1;
            document.querySelector('.static-desktop .static__item-img').style.transform = 'translateY(3150px)';
            document.querySelector('.static-desktop .static__item-img img').setAttribute( 'src', imageUrl);
        }


       if(typeof args.currentElements['static-section-two-1'] === 'object') {
           const staticElement = args.currentElements['static-section-two-1'].el;
           const imageUrl = staticElement.dataset.image;
           document.querySelectorAll('.static-desktop--two .static__item').forEach(item => {
             item.style.opacity = 0.4;
           })
           staticElement.style.opacity = 1;
           document.querySelector('.static-desktop--two .static__item-img').style.transform = 'translateY(0px)';
           document.querySelector('.static-desktop--two .static__item-img video').setAttribute( 'src', imageUrl);
           document.querySelector('body').style.overflow = "hidden";
        }

        if(typeof args.currentElements['static-section-two-2'] === 'object') {
          const staticElement = args.currentElements['static-section-two-2'].el;
          const imageUrl = staticElement.dataset.image;
          document.querySelectorAll('.static-desktop--two .static__item').forEach(item => {
            item.style.opacity = 0.4;
          })
          staticElement.style.opacity = 1;
          document.querySelector('.static-desktop--two .static__item-img').style.transform = 'translateY(350px)';
          document.querySelector('.static-desktop--two .static__item-img video').setAttribute( 'src', imageUrl);
       }

       if(typeof args.currentElements['static-section-two-3'] === 'object') {
          const staticElement = args.currentElements['static-section-two-3'].el;
          const imageUrl = staticElement.dataset.image;
          document.querySelectorAll('.static-desktop--two .static__item').forEach(item => {
            item.style.opacity = 0.4;
          })
          staticElement.style.opacity = 1;
          document.querySelector('.static-desktop--two .static__item-img').style.transform = 'translateY(700px)';
          document.querySelector('.static-desktop--two .static__item-img video').setAttribute( 'src', imageUrl);
       }

       if(typeof args.currentElements['static-section-two-4'] === 'object') {
          const staticElement = args.currentElements['static-section-two-4'].el;
          const imageUrl = staticElement.dataset.image;
          document.querySelectorAll('.static-desktop--two .static__item').forEach(item => {
            item.style.opacity = 0.4;
          })
          staticElement.style.opacity = 1;
          document.querySelector('.static-desktop--two .static__item-img').style.transform = 'translateY(1050px)';
          document.querySelector('.static-desktop--two .static__item-img video').setAttribute( 'src', imageUrl);
       }

       if(typeof args.currentElements['static-section-two-5'] === 'object') {
          const staticElement = args.currentElements['static-section-two-5'].el;
          const imageUrl = staticElement.dataset.image;
          document.querySelectorAll('.static-desktop--two .static__item').forEach(item => {
            item.style.opacity = 0.4;
          })
          staticElement.style.opacity = 1;
          document.querySelector('.static-desktop--two .static__item-img').style.transform = 'translateY(1400px)';
          document.querySelector('.static-desktop--two .static__item-img video').setAttribute( 'src', imageUrl);
       }

        if(typeof args.currentElements['static-section-two-6'] === 'object') {
            const staticElement = args.currentElements['static-section-two-6'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop--two .static__item').forEach(item => {
                item.style.opacity = 0.4;
            })
            staticElement.style.opacity = 1;
            document.querySelector('.static-desktop--two .static__item-img').style.transform = 'translateY(1750px)';
            document.querySelector('.static-desktop--two .static__item-img img').setAttribute( 'src', imageUrl);
        }

        if(typeof args.currentElements['static-section-two-7'] === 'object') {
            const staticElement = args.currentElements['static-section-two-7'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop--two .static__item').forEach(item => {
                item.style.opacity = 0.4;
            })
            staticElement.style.opacity = 1;
            document.querySelector('.static-desktop--two .static__item-img').style.transform = 'translateY(2100px)';
            document.querySelector('.static-desktop--two .static__item-img img').setAttribute( 'src', imageUrl);
        }

        if(typeof args.currentElements['static-section-two-8'] === 'object') {
            const staticElement = args.currentElements['static-section-two-8'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop--two .static__item').forEach(item => {
                item.style.opacity = 0.4;
            })
            staticElement.style.opacity = 1;
            document.querySelector('.static-desktop--two .static__item-img').style.transform = 'translateY(2450px)';
            document.querySelector('.static-desktop--two .static__item-img img').setAttribute( 'src', imageUrl);
        }

        if(typeof args.currentElements['static-section-two-9'] === 'object') {
            const staticElement = args.currentElements['static-section-two-9'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop--two .static__item').forEach(item => {
                item.style.opacity = 0.4;
            })
            staticElement.style.opacity = 1;
            document.querySelector('.static-desktop--two .static__item-img').style.transform = 'translateY(2800px)';
            document.querySelector('.static-desktop--two .static__item-img img').setAttribute( 'src', imageUrl);
        }

        if(typeof args.currentElements['static-section-two-10'] === 'object') {
            const staticElement = args.currentElements['static-section-two-10'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop--two .static__item').forEach(item => {
                item.style.opacity = 0.4;
            })
            staticElement.style.opacity = 1;
            document.querySelector('.static-desktop--two .static__item-img').style.transform = 'translateY(3150px)';
            document.querySelector('.static-desktop--two .static__item-img img').setAttribute( 'src', imageUrl);
        }







        if(typeof args.currentElements['static-section-home-1'] === 'object') {
            const staticElement = args.currentElements['static-section-home-1'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop--home .static__item').forEach(item => {
                item.classList.remove('static__item--active');
            })
            staticElement.classList.add('static__item--active');
            document.querySelector('.static-desktop--home .static__item-img').style.transform = 'translateY(0px)';
            document.querySelector('.static-desktop--home .static__item-img img').setAttribute( 'src', imageUrl);
            document.querySelector('body').style.overflow = "hidden";
        }

        if(typeof args.currentElements['static-section-home-2'] === 'object') {
            const staticElement = args.currentElements['static-section-home-2'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop--home .static__item').forEach(item => {
                item.classList.remove('static__item--active');
            })
            staticElement.classList.add('static__item--active');
            document.querySelector('.static-desktop--home .static__item-img').style.transform = 'translateY(350px)';
            document.querySelector('.static-desktop--home .static__item-img img').setAttribute( 'src', imageUrl);
        }

        if(typeof args.currentElements['static-section-home-3'] === 'object') {
            const staticElement = args.currentElements['static-section-home-3'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop--home .static__item').forEach(item => {
                item.classList.remove('static__item--active');
            })
            staticElement.classList.add('static__item--active');
            document.querySelector('.static-desktop--home .static__item-img').style.transform = 'translateY(700px)';
            document.querySelector('.static-desktop--home .static__item-img img').setAttribute( 'src', imageUrl);
        }

        if(typeof args.currentElements['static-section-home-4'] === 'object') {
            const staticElement = args.currentElements['static-section-home-4'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop--home .static__item').forEach(item => {
                item.classList.remove('static__item--active');
            })
            staticElement.classList.add('static__item--active');
            document.querySelector('.static-desktop--home .static__item-img').style.transform = 'translateY(1050px)';
            document.querySelector('.static-desktop--home .static__item-img img').setAttribute( 'src', imageUrl);
        }

        if(typeof args.currentElements['static-section-home-5'] === 'object') {
            const staticElement = args.currentElements['static-section-home-5'].el;
            const imageUrl = staticElement.dataset.image;
            document.querySelectorAll('.static-desktop--home .static__item').forEach(item => {
                item.style.opacity = 0.3;
            })
            staticElement.style.opacity = 1;
            document.querySelector('.static-desktop--home .static__item-img').style.transform = 'translateY(1400px)';
            document.querySelector('.static-desktop--home .static__item-img img').setAttribute( 'src', imageUrl);
        }





        if(typeof args.currentElements['product-background'] === 'object') {
          let progress = args.currentElements['product-background'].progress;
          let currentScale = 2.2 - (progress * 1.2) ;

          if(currentScale > 1) {
            document.querySelector('.template-product .main-background').style.transform = 'scale(' + currentScale +')';
          }
       }

       if(args.scroll.y >= 130) {
         document.querySelector('body').classList.add('start-scrolling');
         document.querySelector('.header').classList.add('active');
         document.querySelector('.header__inner.icon').classList.add('active');
       } else if (args.scroll.y <= 75) {
           document.querySelector('body').classList.remove('start-scrolling');
           document.querySelector('.header').classList.remove('active');
         document.querySelector('.header__inner.icon').classList.remove('active');
       }

       if(document.querySelector('body').classList.contains('template-product')) {
         const stickyHeight = 86 - (args.scroll.y / 10);

         if(stickyHeight > 12) {
           document.querySelector('.sticky').style.bottom = stickyHeight + 'vh';
         } else {
           document.querySelector('.sticky').style.bottom = '11vh';
         }
       }
    });


//     scroll.on('call', (call) => {
//        if(call === 'color_inverse_white') {
//          if(document.body.classList.contains('template-index')) {
// //           document.body.style.background = '#fff';
// //           document.body.style.color = '#000';
//          }
//          document.body.classList.add('background-white');
//          document.body.classList.remove('background-black');
//        } else if (call === 'color_inverse_black') {
//          if(document.body.classList.contains('template-index')) {
// //           document.body.style.background = '#000';
// //           document.body.style.color = '#fff';
//          }
//           document.body.classList.add('background-black');
//           document.body.classList.remove('background-white');
//        }
//     })


    document.querySelectorAll('.card-item').forEach(card => {
        card.addEventListener("mouseenter", function( event ) {
           event.target.querySelector('.card-button').style.opacity = '1';
           event.target.querySelector('.card-item__overlay').style.opacity = '0.5';
        })

        card.addEventListener("mouseleave", function( event ) {
          event.target.querySelector('.card-button').style.opacity = '0';
          event.target.querySelector('.card-item__overlay').style.opacity = '0';
       })
    })

    document.querySelectorAll('.collabs .swiper-slide-wrap').forEach(slide => {
       slide.addEventListener("mouseenter", function( event ) {
         event.target.querySelector('.card-item__overlay').style.opacity = '0.5';
       })

       slide.addEventListener("mouseleave", function( event ) {
         event.target.querySelector('.card-item__overlay').style.opacity = '0';
       })
    })

    const productImage = document.querySelector(".template-product #top");
    const productBackgroundImage = document.querySelector('.main-background');
    let moveTimer, settleIntervalDown, settleIntervalUp, settleUp, settleFinish, previousX, previousY;

    productImage.addEventListener("mousemove", (e) => {
      var rect = document.querySelector(".template-product #top").getBoundingClientRect();

      var offset = {
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
      };

      var mouseX = e.pageX - offset.left;
      var mouseY = e.pageY - offset.top;
      var totalX = rect.width;
      var totalY = rect.height;
      var centerX = totalX / 2;
      var centerY = totalY / 2;
      var shiftX = centerX - mouseX;
      var shiftY = centerY - mouseY;

      var startX = (rect.width / 2) - (rect.width / 2);
      var startY = (rect.height / 2) - (rect.height / 2);

      let left = startX + (shiftX/10);
      let top = startY + (shiftY/10);
      let imageTop, imageLeft;

      top < 0 ? imageTop = Math.abs(top) : imageTop = -Math.abs(top);
      left < 0 ? imageLeft = Math.abs(left) : imageLeft = -Math.abs(left);

      productBackgroundImage.style.backgroundPositionY = top + 'px';
      productBackgroundImage.style.backgroundPositionX = left + 'px';
      //document.querySelector('.template-product #top img').style.left = imageLeft + 'px';
      //document.querySelector('.template-product #top img').style.top = imageTop + 'px';

      let directionX, directionY;

      previousX < mouseX ? directionX = 'right' : directionX = 'left';
      previousY < mouseY ? directionY = 'bottom' : directionY = 'top';

      clearTimeout(moveTimer);
      clearInterval(settleIntervalDown);
      clearInterval(settleIntervalUp);
      clearTimeout(settleUp);
      clearTimeout(settleFinish);
      moveTimer = setTimeout(function(){
        settleIntervalDown = setInterval(function() {
          if(directionY === 'top') {
            imageTop = imageTop - .05;
            top = top + .05;
          } else {
            imageTop = imageTop + .05;
            top = top - .05;
          }

          if(directionX === 'left') {
            imageLeft = imageLeft - .05;
            left = left + .05;
          } else {
            imageLeft = imageLeft + .05;
            left = left - .05;
          }


          productBackgroundImage.style.backgroundPositionY = top + 'px';
          productBackgroundImage.style.backgroundPositionX = left + 'px';
          //document.querySelector('.template-product #top img').style.left = imageLeft + 'px';
          //document.querySelector('.template-product #top img').style.top = imageTop + 'px';
        }, 10);
        settleUp = setTimeout(function(){
          clearInterval(settleIntervalDown);
          settleIntervalUp = setInterval(function() {
          if(directionY === 'top') {
            imageTop = imageTop + .05;
            top = top - .05;
          } else {
            imageTop = imageTop - .05;
            top = top + .05;
          }

          if(directionX === 'left') {
            imageLeft = imageLeft + .05;
            left = left - .05;
          } else {
            imageLeft = imageLeft - .05;
            left = left + .05;
          }

            productBackgroundImage.style.backgroundPositionY = top + 'px';
            productBackgroundImage.style.backgroundPositionX = left + 'px';
            //document.querySelector('.template-product #top img').style.left = imageLeft + 'px';
            //document.querySelector('.template-product #top img').style.top = imageTop + 'px';
          }, 10);
          settleFinish = setTimeout(function(){
            clearInterval(settleIntervalUp);
          }, 3000);
        }, 3000);
        previousX = mouseX;
        previousY = mouseY;
      },100)


    });




    let ignoreClickOnMeElement = null;

    $('.template-product .description__inner .description__poptitle').on('click', function() {
        const popup = $(this).find('.content__poptitle').clone();
        $('.js-content-popup').html(popup);
        setTimeout(function () {
            $('body').addClass('all-to-left');
            $('#scroll-container').removeClass('transform-none');
        }, 0);
        ignoreClickOnMeElement = document.querySelector('.js-content-popup');
    });

    $(document).on('click', '.template-product .js-content-popup .description.close', function () {
        $('.template-product.overlay').click();
        $('body').removeClass('all-to-left');
        setTimeout(function () {
            $('.js-content-popup').html();
        }, 500);
    });

    document.addEventListener('click', function(event) {
        var isClickInsideElement = ignoreClickOnMeElement && ignoreClickOnMeElement.contains(event.target);
        if (!isClickInsideElement) {
            $('body').removeClass('all-to-left');
            // $('#shopify-section-product-template').removeClass('overlay');
            // $('#scroll-container').removeClass('transform-none-variants');
            // $('.variants-popup').removeClass('is-open');
            // $('.ajax-cart').removeClass('is-open');
            scrollDesktop.start();
            setTimeout(function () {
                $('.js-content-popup').html();
            }, 500);
        }
    });

    $(document).on('click', '.variants-overlay', function () {
        $(this).removeClass('variants-overlay--active');
        $('#scroll-container').removeClass('transform-none-variants');
        $('.variants-popup').removeClass('is-open');
        $('.ajax-cart').removeClass('is-open');
    });


    $(document).on('click', '.template-product .button-cartt .btn.add-to-bag', function () {
        $('body').addClass('overlay');
    });

    $(document).on('click', '.template-product .button-cart.popup .btn.add-to-bag', function () {
        ignoreClickOnMeElement = document.querySelector('.variants-popup');
        $('body').removeClass('overlay');
        $('#scroll-container').removeClass('transform-none');
        console.log(currentProgress);
        // window.scrollTo(0, currentProgress);
        setTimeout(function () {
            $('.variants-overlay').addClass('variants-overlay--active');
            $('#scroll-container').addClass('transform-none-variants');
            $('.variants-popup').addClass('is-open');
            scrollDesktop.stop();
        }, 0);
    });




    document.querySelector('.sticky .item-tab.top') && document.querySelector('.sticky .item-tab.top').addEventListener('click', () => {
      target = document.getElementById('top');
      scrollDesktop.scrollTo(target);
    });

    document.querySelector('.sticky .item-tab.details') && document.querySelector('.sticky .item-tab.details').addEventListener('click', () => {
      target = document.getElementById('details');
        scrollDesktop.scrollTo(target);
    });

    document.querySelector('.sticky .item-tab.features') && document.querySelector('.sticky .item-tab.features').addEventListener('click', () => {
      target = document.getElementById('features');
        scrollDesktop.scrollTo(target);
    });

    document.querySelector('.sticky .item-tab.gallery') && document.querySelector('.sticky .item-tab.gallery').addEventListener('click', () => {
      target = document.getElementById('gallery');
        scrollDesktop.scrollTo(target);
    });

    document.querySelector('.sticky .item-tab.video') && document.querySelector('.sticky .item-tab.video').addEventListener('click', () => {
      target = document.getElementById('video');
        scrollDesktop.scrollTo(target);
    });

    document.querySelector('.sticky .item-tab.works') && document.querySelector('.sticky .item-tab.works').addEventListener('click', () => {
      target = document.getElementById('works');
        scrollDesktop.scrollTo(target);
    });

    document.querySelector('.sticky').style.top = '86vh';
    setTimeout(function(){
      document.querySelector('.sticky').style.transition = 'none';
    }, 1000);
};

$(document).ready(function () {
    $('.js-progress-scroll').on("click",function(){
        if (scrollDesktop) {
            scrollDesktop.scrollTo(0, 0);
        } else {
           window.scrollTo(0, 0);
        }
    });
});


const initMobileAnimation = () => {
  var scroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true
  });

  scroll.on('scroll', (args) => {
    if(typeof args.currentElements['background-image'] === 'object') {
      let progress = args.currentElements['background-image'].progress;
      currentOpacity =  1.6 - (progress * 1.2);
      document.querySelector('.background-image-container').style.opacity = currentOpacity;
    }

      // if(typeof args.currentElements['keep-section'] === 'object') {
      //     let progress = args.currentElements['keep-section'].progress;
      //     currentOpacity =  1.6 - (progress * 1.2);
      //     console.log(currentOpacity);
      //     document.querySelector('.keep__content').style.opacity = currentOpacity;
      // }

    if(typeof args.currentElements['card-section'] === 'object') {
      let progress = args.currentElements['card-section'].progress;
      let currentScale = 1.4 - (progress / 2) ;

      document.querySelectorAll('.card-item__bg img').forEach(card => {
        card.style.transform = 'scale(' + currentScale +')';
      })
    }

    if(typeof args.currentElements['expanding-video'] === 'object') {
      let progress = args.currentElements['expanding-video'].progress;
      let currentSize = 40 - (progress * 80);

      if(currentSize > -1){
        document.querySelector('.ambassador-pdp-video .border-left').style.width = currentSize + 'px';
        document.querySelector('.ambassador-pdp-video .border-right').style.width = currentSize + 'px';
        document.querySelector('.ambassador-pdp-video .border-top').style.height = currentSize + 'px';
      } else {
        document.querySelector('.ambassador-pdp-video .border-left').style.width = '0px';
        document.querySelector('.ambassador-pdp-video .border-right').style.width = '0px';
        document.querySelector('.ambassador-pdp-video .border-top').style.height = '0px';
      }

      let textTop = 300 - (progress * 600);

      if(document.querySelector('body').classList.contains('template-product')) {
        if(textTop > 65) {
          document.querySelector('.ambassador-pdp-video .slow-content').style.top = textTop + 'vh';
        } else {
          document.querySelector('.ambassador-pdp-video .slow-content').style.top = '65vh';
        }
      } else {
        if(textTop > -1) {
          document.querySelector('.ambassador-pdp-video .slow-content').style.top = textTop + 'vh';
        } else {
          document.querySelector('.ambassador-pdp-video .slow-content').style.top = '0';
        }
      }
    }

      if(typeof args.currentElements['full-width-pdp-image'] === 'object') {
          let progress = args.currentElements['full-width-pdp-image'].progress;
          let currentSize = 40 - (progress * 80);

          if(currentSize > -1){
              document.querySelector('.full-width-pdp-image .border-left').style.width = currentSize + 'px';
              document.querySelector('.full-width-pdp-image .border-right').style.width = currentSize + 'px';
              document.querySelector('.full-width-pdp-image .border-top').style.height = currentSize + 'px';
          } else {
              document.querySelector('.full-width-pdp-image .border-left').style.width = '0px';
              document.querySelector('.full-width-pdp-image .border-right').style.width = '0px';
              document.querySelector('.full-width-pdp-image .border-top').style.height = '0px';
          }

          let textTop = 300 - (progress * 600);

          if(document.querySelector('body').classList.contains('template-product')) {
              if(textTop > 65) {
                  document.querySelector('.full-width-pdp-image .slow-content').style.top = textTop + 'vh';
              } else {
                  document.querySelector('.full-width-pdp-image .slow-content').style.top = '65vh';
              }
          } else {
              if(textTop > -1) {
                  document.querySelector('.full-width-pdp-image .slow-content').style.top = textTop + 'vh';
              } else {
                  document.querySelector('.full-width-pdp-image .slow-content').style.top = '0';
              }
          }
      }

      if(typeof args.currentElements['keep-section'] === 'object') {
          let progress = args.currentElements['keep-section'].progress;
          let currentSize = 40 - (progress * 80);
          // let titleOpacity;

          if(currentSize > -1){
              document.querySelector('.keep .border-left').style.width = currentSize + 'px';
              document.querySelector('.keep .border-right').style.width = currentSize + 'px';
              document.querySelector('.keep .border-top').style.height = currentSize + 'px';
          } else {
              document.querySelector('.keep .border-left').style.width = '0px';
              document.querySelector('.keep .border-right').style.width = '0px';
              document.querySelector('.keep .border-top').style.height = '0px';
          }

          let textTop = 300 - (progress * 600);

          if(document.querySelector('body').classList.contains('template-index')) {
              if(textTop > 65) {
                  document.querySelector('.keep__content').style.top = textTop + 'vh';
              } else {
                  document.querySelector('.keep__content').style.top = '65vh';
              }
          } else {
              if(textTop > -1) {
                  document.querySelector('.keep__content').style.top = textTop + 'vh';
              } else {
                  document.querySelector('.keep__content').style.top = '0';
              }
          }
      }

  });

//   scroll.on('call', (call) => {
//     if(call === 'color_inverse_white') {
//       if(document.body.classList.contains('template-index')) {
//        document.body.style.background = '#fff';
//        document.body.style.color = '#000';
//       }
//       document.body.classList.add('background-white');
//       document.body.classList.remove('background-black');
//     } else if (call === 'color_inverse_black') {
//       if(document.body.classList.contains('template-index')) {
//        document.body.style.background = '#000';
//        document.body.style.color = '#fff';
//       }
//        document.body.classList.add('background-black');
//        document.body.classList.remove('background-white');
//     }
//  });

  function titleParallax() {
    const title = document.querySelector(".title-container");
    var titleTop = (window.pageYOffset / 2);
    title.style.top = '-' +titleTop + 'px';
  }

  window.addEventListener("scroll", function(){
    titleParallax();
  });
};

if (document.querySelector('body').classList.contains('template-product') || document.querySelector('body').classList.contains('template-index')) {
  if(window.screen.width > 1024){
    initLoco();
    document.addEventListener("shopify:section:load", initLoco);
  } else {
    initMobileAnimation();
    document.addEventListener("shopify:section:load", initMobileAnimation);
  }
}

var ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};

ready(() => {
  if(document.querySelector('body').classList.contains('sufix-about-us')) {
    document.querySelector('.main').classList.add('in-view');
  }

  const progressBar = document.querySelector('.progress-bar');

  if(typeof(progressBar) != 'undefined' && progressBar != null) {
    const pageHeight = document.documentElement.scrollHeight;
    let currentProgress;

    const checkProgress = () => {
      let scrollPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
      currentProgress = (scrollPos / pageHeight) * 120;
      if(currentProgress <= 100) {
        document.querySelector('.progress-bar__progress').style.width = currentProgress + '%';
      } else {
        document.querySelector('.progress-bar__progress').style.width = '100%';
      }
    }

    checkProgress();

    window.addEventListener("scroll", function(){
      checkProgress();
    });
  }
})
